export default __webpack_public_path__ + "static/media/megan.c6ba4fa3.jpeg";